import {useMemo} from "react";

import {useRecentFilters} from "../../search/hooks/use_recent_filters";
import {IPersonalizedHomepageBackgroundImages} from "../components/PersonalizedHomepage/PersonalizedHomepageHero";
import {getHeroCityNameFromRecentFilters, getPersonalizedHeroBackground} from "../utils/get_personalized_hero_background";

export const usePersonalizedHeroBackground = (): IPersonalizedHomepageBackgroundImages => {
    const {recentFilters} = useRecentFilters();

    return useMemo(() => {
        const cityName = getHeroCityNameFromRecentFilters(recentFilters) ?? recentFilters[0]?.search?.label;

        return getPersonalizedHeroBackground(cityName);
    }, [recentFilters]);
};
import {useMemo} from "react";

import {useRecentFilters} from "../../search/hooks/use_recent_filters";
import {IPersonalizedHomepageBackgroundImages} from "../components/PersonalizedHomepage/PersonalizedHomepageHero";
import {getHeroCityNameFromRecentFilters, getPersonalizedHeroBackground} from "../utils/get_personalized_hero_background";

export const usePersonalizedHeroBackground = (): IPersonalizedHomepageBackgroundImages => {
    const {recentFilters} = useRecentFilters();

    return useMemo(() => {
        const cityName = getHeroCityNameFromRecentFilters(recentFilters) ?? recentFilters[0]?.search?.label;

        return getPersonalizedHeroBackground(cityName);
    }, [recentFilters]);
};
